import { RowTypes } from '../../enums/pdf-tron/row-types.enum';

export interface INotesMovementScheduleData {
    rowType: RowTypes;
    t: string | null;
    col1?: string | null;
    col2?: string | null;
    col3?: string | null;
    col4?: string | null;
    pV?: string | null;
    cV?: string | null;
}
